import React from 'react';

import { Route } from 'react-router-dom';
import FallBackRoute from './FallBackRoute';
import MainControlScreen from '../components/screens/MainControlScreen';
import ContinueEmission from '../components/screens/ContinueEmission';
import DashboardScreen from '../components/screens/DashboardScreen';

export default [
  <Route
    key="dashboard"
    path="/"
    element={<MainControlScreen component={<DashboardScreen />} />}
  />,
  <Route
    key="dashboard"
    path="/emission/continue"
    element={<MainControlScreen component={<ContinueEmission />} />}
  />,
  <Route path="*" key="fallback" element={<FallBackRoute />} />,
];
